import { render } from "./FinnProjectStatistics.vue?vue&type=template&id=f97341e0&scoped=true"
import script from "./FinnProjectStatistics.vue?vue&type=script&lang=js"
export * from "./FinnProjectStatistics.vue?vue&type=script&lang=js"

import "./FinnProjectStatistics.vue?vue&type=style&index=0&id=f97341e0&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97341e0"]])

export default __exports__